import { FlowRunBlockMetricTypeFilter } from 'flow-schema';
import z from 'zod';

export const flowRunBlockMetricSchema = z.object({
  id: z.string(),
  created: z.string().datetime(),
  updated: z.string().datetime(),
  organizationId: z.string(),
  flowRunBlockId: z.string(),
  blockId: z.string().nullable(),
  flowRunId: z.string(),
  metricName: z.string(),
  metricValue: z.number(),
  metadata: z.record(z.string(), z.string()).optional().nullable(),
  flowRunStartTime: z.string().datetime(),
  blockType: z.string(),
  practiceId: z.string().nullable(),
  entityId: z.string().nullable(),
  entityType: z.string().nullable(),
  flowDefinitionId: z.string(),
  agentId: z.string().nullable(),
  flowId: z.string().nullable(),
  snapshotId: z.string().nullable(),
});

export type FlowRunBlockMetric = z.infer<typeof flowRunBlockMetricSchema>;

export const findAllParamsSchema = z.object({
  flowRunId: z.string(),
  metricTypeFilter: z.enum(FlowRunBlockMetricTypeFilter).optional(),
});

export type FlowRunBlockMetricFindAllParams = z.infer<typeof findAllParamsSchema>;
